(() => {
  const ROOT = '[data-embe-campaign]';

  function destroyProductSwipers(rootEl, exceptPanel) {
    rootEl.querySelectorAll?.('[data-embe-campaign-products-swiper]')?.forEach?.((el) => {
      if (exceptPanel && exceptPanel.contains(el)) return;
      const sw = el._embeCampaignSwiper || el.swiper;
      if (!sw) return;
      try {
        sw.destroy?.(true, true);
      } catch (e) {
        // ignore
      }
      delete el._embeCampaignSwiper;
    });
  }

  function initProductSwipers(panel) {
    if (!window.Swiper) return;
    panel.querySelectorAll?.('[data-embe-campaign-products-swiper]')?.forEach?.((el) => {
      if (el._embeCampaignSwiper) return;
      const prev = el.querySelector('.swiper-button-prev');
      const next = el.querySelector('.swiper-button-next');
      const pagination = el.querySelector('.swiper-pagination');

      const opts = {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 16,
        speed: 500,
        roundLengths: true,
        watchOverflow: true,
        // observer: true,
        observeParents: true,
        grid: {
          rows: 2,
          fill: 'row',
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            slidesPerGroup: 1,
            spaceBetween: 12,
            grid: {
              rows: 1,
              fill: 'row',
            },
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 12,
            grid: {
              rows: 1,
              fill: 'row',
            },
          },
          750: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            grid: {
              rows: 1,
              fill: 'row',
            },
          },
          1080: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
            grid: {
              rows: 2,
              fill: 'row',
            },
          },
          1600: {
            spaceBetween: 20,
          }
        },
      };

      if (prev && next) opts.navigation = { prevEl: prev, nextEl: next };
      if (pagination) opts.pagination = { el: pagination, clickable: true };

      try {
        el._embeCampaignSwiper = new window.Swiper(el, opts);
        el._embeCampaignSwiper.on('init', () => syncCampaignHeight(panel.closest('[data-embe-campaign]')));
        el._embeCampaignSwiper.on('update', () => syncCampaignHeight(panel.closest('[data-embe-campaign]')));
        el._embeCampaignSwiper.on('resize', () => syncCampaignHeight(panel.closest('[data-embe-campaign]')));
      } catch (e) {
        // Keep content visible even if Swiper crashes (e.g. missing module / bad opts).
        el.classList.remove('swiper-initialized');
        el.classList.add('embe-swiper-failed');
        el._embeCampaignSwiper = null;
        return;
      }
    });
  }

  function syncCampaignHeight(section) {
    if (!section) return;

    const left = section.querySelector('.embe-campaign__left');
    const right = section.querySelector('.embe-campaign__right');

    if (!left || !right) return;

    if (window.matchMedia('(max-width: 989px)').matches) {
      left.style.removeProperty('height');
      return;
    }

    const targetHeight = right.getBoundingClientRect().height;
    if (!targetHeight) return;

    left.style.height = `${Math.round(targetHeight)}px`;
  }

  function syncActive(rootEl, idx) {
    const viewport = rootEl.querySelector('[data-embe-campaign-products]');
    const track = rootEl.querySelector('[data-embe-campaign-products-track]');
    const panels = rootEl.querySelectorAll('[data-embe-campaign-products-panel]');
    const panel = panels[idx];
    if (!viewport || !panel) return;

    viewport.style.setProperty('--embe-campaign-active', String(idx));
    panels.forEach((p, i) => p.setAttribute('aria-hidden', i === idx ? 'false' : 'true'));

    // Only the active panel should keep Swiper instances. Inactive panels still exist in the
    // flex row and (with Swiper Grid) can inflate the track's cross-size, creating huge whitespace.
    destroyProductSwipers(rootEl, panel);
    initProductSwipers(panel);

    const syncSwiper = () => {
      panel.querySelectorAll?.('[data-embe-campaign-products-swiper]')?.forEach?.((el) => {
          const sw = el._embeCampaignSwiper;
          if (!sw) return;
          sw.updateSize?.();
          sw.updateSlides?.();
          sw.updateProgress?.();
          sw.updateSlidesClasses?.();
          sw.update?.();
          // if (window.matchMedia('(min-width: 1080px)').matches) {
          //   sw.slideTo?.(0, 0, false);
          // }
      });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => syncCampaignHeight(rootEl));
      });
    };

    if (track) {
      const onEnd = (e) => {
        if (e.propertyName && e.propertyName !== 'transform') return;
        track.removeEventListener('transitionend', onEnd);
        syncSwiper();
      };
      track.addEventListener('transitionend', onEnd);
      setTimeout(syncSwiper, 450);
    } else {
      requestAnimationFrame(() => requestAnimationFrame(syncSwiper));
    }
  }

  function init(root = document) {
    // Allow calling init(sectionEl) as well as init(document)
    let sections;
    if (root.matches?.(ROOT)) {
      sections = [root];
    } else {
      const found = root.querySelectorAll?.(ROOT);
      sections = found && found.length ? found : document.querySelectorAll(ROOT);
    }
    sections.forEach((section) => {
      const campaignsEl = section.querySelector('[data-embe-campaigns-swiper]');
      if (!campaignsEl) return;

      // Swiper is loaded with defer in theme; retry if this section runs before Swiper is ready.
      if (!window.Swiper) {
        if (section.dataset.embeInit === 'pending') return;
        section.dataset.embeInit = 'pending';
        let tries = 0;
        const timer = setInterval(() => {
          tries += 1;
          if (window.Swiper) {
            clearInterval(timer);
            // Allow layout to settle (images/fonts) before init.
            requestAnimationFrame(() => init(section));
            return;
          }
          if (tries >= 30) clearInterval(timer);
        }, 100);
        return;
      }

      if (section.dataset.embeInit === '1') return;
      section.dataset.embeInit = '1';

      const prev = campaignsEl.querySelector('.swiper-button-prev');
      const next = campaignsEl.querySelector('.swiper-button-next');
      const pagination = campaignsEl.querySelector('.swiper-pagination');

      const opts = {
        slidesPerView: 1,
        effect: 'fade',
        speed: 600,
        roundLengths: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        fadeEffect: {
          crossFade: true
        }
      };
      if (prev && next) opts.navigation = { prevEl: prev, nextEl: next };
      if (pagination) opts.pagination = { el: pagination, clickable: true };

      let sw;
      try {
        sw = new window.Swiper(campaignsEl, opts);
      } catch (e) {
        campaignsEl.classList.remove('swiper-initialized');
        campaignsEl.classList.add('embe-swiper-failed');
        return;
      }

      const apply = () => {
        syncActive(section, sw.realIndex ?? sw.activeIndex ?? 0);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => syncCampaignHeight(section));
        });
      };
      sw.on('slideChange', apply);
      sw.on('transitionEnd', apply);
      apply();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  window.addEventListener('load', () => {
    document.querySelectorAll('[data-embe-campaign]').forEach(syncCampaignHeight);
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-embe-campaign]').forEach(syncCampaignHeight);
  });

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

